// extracted by mini-css-extract-plugin
export default {"table":"DigitizationTable_table__9jaUb","message":"DigitizationTable_message__fqziI"};